<template>
	<Referrer :uid="uid" />
</template>

<script>
	import Referrer from '@/components/user/referrer'
    export default {
	    components: {Referrer},
        name: "affiliate",
        props:{
            uid: {
                type: Number,
                default: 0
            }
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/user/affiliate/affiliate.vue